import callPiggybackAPI from "../Helpers/piggyback.api.helper";
import { toast } from "react-toastify";


export const refreshDigitalTags = async (tenantId, siteId, digitalTagIds) => {
  try {
    const apiResponse = await callPiggybackAPI(
      "digitalTag/refresh",
      { tenantId, siteId },
      { digitalTagIds },
      "POST"
    );

    if (apiResponse) {
      toast.success("Tags successfully refreshed!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return true;
    } else {
      toast.error("Refresh failed. Please try again.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return false;
    }
  } catch (error) {
    console.error("An unexpected error occurred during refresh:", error);
    toast.error("An unexpected error occurred during refresh.");
    return false;
  }
};